class WheelhouseMapElement extends HTMLElement {
	bounds = new mapboxgl.LngLatBounds();

	addMarketToBounds(marker) {
		this.bounds.extend(marker.getLngLat());

		this.map.fitBounds(this.bounds, {
			padding: Math.min(Math.max((innerWidth - 300) / 2, 0), 300)
		});
	}

	connectedCallback() {
		this.container = document.createElement("div");
		this.container.classList.add("wh-map--container");

		this.append(this.container);

		mapboxgl.accessToken = "pk.eyJ1IjoiamVzc2UtYXQtcHJpc21hIiwiYSI6ImNsZjhkeG05bTI0ejMzeWxoZ2QxenJ6eDYifQ.z5AaeH2YuL6Jm2mNRRr-3g";
		this.map = new mapboxgl.Map({
			container: this.container,
			style: "mapbox://styles/jesse-at-prisma/clf76izqu002j01o5a15rip99",
			scrollZoom: false,
		});

		this.map.addControl(new mapboxgl.NavigationControl());
	}
}

class WheelhouseListingElement extends HTMLElement {
	get coordinates() {
		let [lat,lng] = this.dataset.coordinates.split(",").map((c) => parseFloat(c.trim()));

		return {
			lat,
			lng,
		}
	}

	connectedCallback() {
		this.infoBox = document.createElement("a");
		this.infoBox.href = this.dataset.url;
		this.infoBox.classList.add("wh-listing--info-box");
		this.infoBox.style.color = this.dataset.color ?? "inherit";

		let relativeBox = document.createElement("div");
		relativeBox.classList.add("wh-listing--relative-box");
		
		let image = this.querySelector("img");
		image.classList.add("wh-listing--image");

		let title = document.createElement("h3");
		title.classList.add("wh-listing--title");
		title.innerText = this.dataset.title;

		this.infoBox.append(image, title);

		relativeBox.append(this.infoBox);

		this.pin = document.createElement("div");
		this.pin.classList.add("wh-listing--pin");
		this.pin.style.color = this.dataset.color;

		if (this.hasAttribute("first"))
			this.pin.classList.add("active");

		this.pin.append(relativeBox);

		this.pin.addEventListener("click", event => {
			if (event.target.classList.contains("wh-listing--relative-box")) {
				event.preventDefault();
				event.stopPropagation();

				let isActive = this.pin.classList.contains("active");

				this.map.querySelectorAll(".wh-listing--pin.active").forEach(pin => {
					pin.classList.remove("active");
				});

				this.pin.classList.toggle("active", !isActive);
			}
		});

		this.map = this.parentElement;

		this.map.map.on("load", () => {
			// Add marker to the map

			this.marker = new mapboxgl.Marker({
				element: this.pin
			});

			this.marker.setLngLat([ this.coordinates.lng, this.coordinates.lat ]);
			this.marker.addTo(this.map.map);

			this.map.addMarketToBounds(this.marker);
		});
	}
}

document.addEventListener("DOMContentLoaded", () => {
	customElements.define("wh-map", WheelhouseMapElement);
	customElements.define("wh-listing", WheelhouseListingElement);
});